import React from "react";
import {Link} from "react-router";
import Icon from "../Icon";
import svgPlace from "../../svgs/place.svg";
import svgOM from '../../svgs/om.svg';
import dollars from "../../dollar-format";
import SortTable from "../SortTable";
import {dateISOtoUS} from "../../date-converter";
import { pricePerFoot } from "../CRUDProperty/CRUDProperty";
import { isAgentUser } from "../../utils";

function integer(value) {
    if (value === undefined || value === null || value === "") return "";
    return Math.round(Number(value)).toLocaleString();
}

function percent(value, withDecimals = true) {
    if (value === undefined || value === null || value === "") return "";
    if (withDecimals)
        return Number(value).toFixed(2) + "%";
    return parseInt(value) + "%";
}

const ListTable = (props) => {
    const {isSuper} = props;
    const {isSeniorAgent, lastVisited} = props;
    const query = props.location.query;
    const storedUserData = JSON.parse(sessionStorage.getItem("userData") || "{}");
       const isAgentRestrictedUser =  isAgentUser(storedUserData)
    const isHSC = query.source === 'HSC';
    const isClosed = query.close_of_escrow_min || query.close_of_escrow_max || query.status === 'Closed' || query.hsc_status === 'Closed';
    const isUnderContract = query.status && query.status === "Under Contract";
    // Listed Date applies to Active rows, whatever filter brought them in (status, modified_by, ...)
    const hasActive = (query.status && query.status === "Active") ||
        (props.listings || []).some(el => el.status === "Active");
    // Sort by Date for HSC && Closed Properties
    // if(isHSC && isClosed)
    // {
    //     props.listings.sort((a,b) => new Date(b.CLOSE_OF_ESCROW) - new Date(a.CLOSE_OF_ESCROW));
    // }
    if(isHSC && isClosed && !query.order)
    {
        props.listings.sort((a,b) => new Date(b.loan_closing_date) - new Date(a.loan_closing_date));
    }
    let columns = [{
        name: "",
        render: (el) => el,
    }];

    if (isHSC) {
        columns.push({
            code: "hsc_status",
            name: "Status",
            render: (el) => el.hsc_status,
        })
        if (isClosed) {
            columns.push({
                code:"loan_closing_date",
                name:"Loan Closing Date",
                textAlign: "center",
                render: (el) => el.loan_closing_date ? dateISOtoUS(el.loan_closing_date) : ""
            });
            // Columns Push for Close of Escrow
                // columns.push({
                //     code:"CLOSE_OF_ESCROW",
                //     name:"Close of Escrow",
                //     render: (el) => el.CLOSE_OF_ESCROW ? dateISOtoUS(el.CLOSE_OF_ESCROW) : ""
                // });
        }
        columns.push({
  name: "om",
  render: (el) => {
    const mediaKit = el.media_kit;

    if (!mediaKit || typeof mediaKit !== "string") return null;

    const link = mediaKit.includes("https")
      ? mediaKit
      : arc.path.media + mediaKit;

    return (
      <Link target="_blank" to={link}>
        <Icon svg={svgOM} />
      </Link>
    );
  },
}, {
            code: "name",
            name: "Name",
            columnStyle: {
                minWidth: 250
            },
            render: (el) => {
                const name = el.name || "Untitled";
         
                const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
					const currentSearch = window.location.search;
					const currentPath = window.location.pathname + currentSearch;
                return isAgentRestrictedUser || isSuper || (isSeniorAgent && (el.source == 'External' || el.source == 'STRIVE') && (el.status != 'Off Market')) ? (
                    <Link
                        className="green"
                        to={{pathname: el.arcimedes_row_id && `${basePath}property/${el.arcimedes_row_id}`,
                        state: { fromListUrl: currentPath }
                        }}>
                        {name}
                    </Link>
                ) : (
                    <a
                        href={`https://www.strivere.com/property/${el.arcimedes_row_id}`}
                        target="_blank">
                        {name}
                    </a>
                )
            },
        }, {
            name: "Map",
            textAlign: "center",
            render: (el) =>
                el.longitude && el.latitude ? (
                    <Link target="_blank" to={{
                        pathname: arc.path.base + "map/" + el.arcimedes_row_id,
                        query: {zoom: 18, mapTypeId: "satellite"},
                    }}>
                        <Icon svg={svgPlace}/>
                    </Link>
                ) : null,
        }, {
            code: "address",
            name: "Address",
            columnStyle: {
                minWidth: 230
            },
            render: (el) =>
                el.address && el.arcimedes_row_id ? (
                    <Link
                        target="_blank"
                        to={{
                            pathname: arc.path.base + "map/" + el.arcimedes_row_id,
                            query: {zoom: 18, mapTypeId: "satellite"},
                        }}
                    >
                        {el.address}
                    </Link>
                ) : null,
        }, {
            code: "city",
            name: "City",
            columnStyle: {
                minWidth: 200
            },
            render: (el) => el.city,
        }, {
            code: "state",
            name: "State",
            textAlign: "center",
            render: (el) => el.state,
        });

        if (isClosed) {
            columns.push({
                code: "sold_price",
                name: "Price at Close",
                textAlign: "right",
                render: (el) => dollars(el.sold_price),
            }, {
                code: "close_cap_rate",
                name: "Close Cap Rate",
                textAlign: "center",
                render: (el) => percent(el.close_cap_rate),
            });
        }

        columns.push({
            code: "hsc_price",
            name: "Price",
            textAlign: "right",
            render: (el) => dollars(el.hsc_price),
        }, {
            code: "capitalization_rate",
            name: "Cap Rate",
            textAlign: "center",
            render: (el) => percent(el.capitalization_rate),
        }, {
            code: "loan_amount",
            name: "Loan Amount",
            textAlign: "right",
            render: (el) => dollars(el.loan_amount),
        }, {
            code: "ltv",
            name: "LTV",
            textAlign: "center",
            render: (el) => percent(el.ltv, false),
        }, {
            code: "down_payment",
            name: "Down Payment",
            textAlign: "right",
            render: (el) => dollars(el.down_payment),
        }, {
            code: "interest_rate",
            name: "Rate",
            textAlign: "center",
            render: (el) => percent(el.interest_rate),
        }, {
            code: "amortization",
            name: "Amo",
            textAlign: "center",
            render: (el) => el.amortization,
        }, {
            code: "term",
            name: "Term",
            textAlign: "center",
            render: (el) => el.term,
        }, {
            code: "lender_name",
            name: "Lender",
            columnStyle: {
                minWidth: 100
            },
            render: (el) => el.lender_name,
        });
    } else {
        if (isClosed) {
            columns.push({
                code: "close_of_escrow",
                name: "Close of Escrow",
                render: (el) => el.close_of_escrow ? dateISOtoUS(el.close_of_escrow) : "",
            });
        }

        // check if filtered status is 'In Negotiation', 'Under Contract', or a combination of the two
        let isNegotiation = false;
        if (query.status) {
            const status = query.status.split(",");
            let count = 0;
            if (status.indexOf("In Negotiation") !== -1) {
                count++;
            }
            if (status.indexOf("Under Contract") !== -1) {
                count++;
            }
            if (count && count === status.length) {
                isNegotiation = true;
            }
        }

        if (hasActive) {
            columns.push({
                code: "listed_date",
                name: "Listed Date",
                render: (el) => el.status === "Active" && el.listed_date ? dateISOtoUS(el.listed_date) : "",
            });
        }

columns.push(
  {
    code: "status",
    name: "Status",
    render: (el) => el.status,
  },
  {
    name: "om",
    render: (el) => {
      const mediaKit = el.media_kit || el.MEDIA_KIT;

      if (!mediaKit || typeof mediaKit !== "string") return null;

      const link = mediaKit.includes("https")
        ? mediaKit
        : arc.path.media + mediaKit;

      return (
        <Link target="_blank" to={link}>
          <Icon svg={svgOM} />
        </Link>
      );
    },
  }
);


        if (isUnderContract) {
            columns.push({
                code: "effective_date",
                name: "Effective Date",
                render: (el) => el.effective_date ? dateISOtoUS(el.effective_date) : '',
            });
        }

        if (isSuper) {
            let formattedName = '';
            columns.push({
                code: "agent_1_last_name",
                name: "Agent",
                columnStyle: {
                    minWidth: 120
                },
                render: (el) => {
                    if (el.agent_1_last_name) {
                        formattedName = el.agent_1_first_name ? el.agent_1_first_name.charAt(0) + '. ': ''
                        formattedName = formattedName + el.agent_1_last_name;
                        return formattedName;
                    }
                    if (el.agent_2_last_name) {
                        formattedName = el.agent_2_first_name ? el.agent_2_first_name.charAt(0) + '. ': ''
                        formattedName = formattedName + el.agent_2_last_name;
                        return formattedName;
                    }
                    if (el.agent_3_last_name) {
                        formattedName = el.agent_3_first_name ? el.agent_3_first_name.charAt(0) + '. ': ''
                        formattedName = formattedName + el.agent_3_last_name;
                        return formattedName;
                    }
                    if (el.agent_4_last_name || el.source !== 'STRIVE') {
                        return "OA";
                    }
                    return "";
                },
            });
        }

        columns.push({
            code: "category",
            name: "category",
            columnStyle: {
                minWidth: 120
            },
            render: (el) =>
                el.category ? el.category.toLowerCase() === 'apartments' ? "Multi-Family" : el.category[0].toUpperCase() + el.category.slice(1) : "",
        });

        columns.push({
            code: "type",
            name: "type",
            render: (el) => (el.category ==='apartments') ? 'MF': el.type,
        });

        columns.push({
            code: "name",
            name: "name",
            columnStyle: {
                minWidth: 250
            },
            render: (el) => {
                const name = el.name || "Untitled";
                const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
					const currentSearch = window.location.search;
					const currentPath = window.location.pathname + currentSearch;
                return isAgentRestrictedUser || isSuper || (isSeniorAgent && (el.source == 'External' || el.source == 'STRIVE') && (el.status != 'Off Market')) ? (
                    <Link
                        className="green"
                        // to={{pathname: `${arc.path.base}property/${el.arcimedes_row_id}`}}>
                        to={{pathname: el.arcimedes_row_id && `${basePath}property/${el.arcimedes_row_id}`,
                        state: { fromListUrl: currentPath }
                        }}>
                        
                        {name}
                    </Link>
                ) : (
                    <a
                        href={`https://www.strivere.com/property/${el.arcimedes_row_id}`}
                        target="_blank">
                        {name}
                    </a>
                )
            },
        });

        columns.push({
            name: "Map",
            textAlign: "center",
            render: (el) =>
                (el.LONGITUDE && el.LATITUDE && el.arcimedes_row_id) || (el.longitude && el.latitude && el.arcimedes_row_id) ? (
                    <Link target="_blank" to={{
                        pathname: arc.path.base + "map/" + el.arcimedes_row_id,
                        query: {zoom: 18, mapTypeId: "satellite"},
                    }}>
                        <Icon svg={svgPlace}/>
                    </Link>
                ) : null,
        });

        columns.push({
            code: "address",
            name: "address",
            columnStyle: {
                minWidth: 230
            },
            render: (el) =>
                (el.address || el.ADDRESS) && el.arcimedes_row_id? (
                    <Link
                        target="_blank"
                        to={{
                            pathname: arc.path.base + "map/" + (el.arcimedes_row_id ?  el.arcimedes_row_id : null),
                            query: {zoom: 18, mapTypeId: "satellite"},
                        }}
                    >
                        {el.address}
                    </Link>
                ) : null
        });

        columns.push({
            code: "city",
            name: "city",
            columnStyle: {
                minWidth: 200
            },
            render: (el) => el.city,
        });

        columns.push({
            code: "state",
            name: "state",
            textAlign: "center",
            render: (el) => el.state,
        });

        if (!isClosed && !isNegotiation) {
            columns.push({
                code: "list_price",
                name: "List Price",
                textAlign: "right",
                render: (el) =>  dollars(el.list_price != null ? el.list_price : (el.hsc_price != null ? el.hsc_price: null)),
            });
            columns.push({
                code: "capitalization_rate",
                name: "Cap Rate",
                textAlign: "center",
                render: (el) => el.is_proforma_pricing=='y' ? percent(el.proforma_cap_rate) : percent(el.capitalization_rate )
            });
        }

        if (isNegotiation) {
            columns.push({
                code: "negotiation_price",
                name: "price",
                textAlign: "right",
                render: (el) => dollars(el.negotiation_price),
            });
            columns.push({
                code: "negotiation_cap_rate",
                name: "cap rate",
                textAlign: "center",
                render: (el) => percent(el.negotiation_cap_rate),
            });
        }

        if (isClosed) {
            columns.push({
                code: "sold_price",
                name: "Price at Close",
                textAlign: "right",
                render: (el) => dollars(el.sold_price),
            });
            columns.push({
                code: "close_cap_rate",
                name: "Close Cap Rate",
                textAlign: "center",
                render: (el) => percent(el.close_cap_rate),
            });
            columns.push({
                code: "close_noi",
                name: "Close NOI",
                textAlign: "right",
                render: (el) => el.is_proforma_pricing=='y' ? dollars(el.proforma_noi) : dollars(el.net_operating_income )                
            });
            columns.push({
                code: "list_price",
                name: "List Price",
                textAlign: "right",
                render: (el) => dollars(el.list_price != null ? el.list_price : (el.hsc_price != null ? el.hsc_price: null)),
            });
            columns.push({
                code: "capitalization_rate",
                name: "Cap Rate",
                textAlign: "center",
                render: (el) => el.is_proforma_pricing=='y' ? percent(el.proforma_cap_rate) : percent(el.capitalization_rate )
            });
        } else {
            columns.push({
                code: "net_operating_income",
                name: "NOI",
                textAlign: "right",
                render: (el) =>  el.is_proforma_pricing=='y' ? dollars(el.proforma_noi) : dollars(el.net_operating_income ),                
            });
        }

        if (isSuper) {
            columns.push({
              code: "sellers_last_name",
              name: "Seller",
              render: (el) => {
                const { sellers_first_name, sellers_last_name } = el;
                return (
                  [sellers_first_name, sellers_last_name]
                    .filter(Boolean)
                    .join(" ") || ""
                );
              },
            });
        }

        columns.push({
            code: "sqft",
            name: "SQFT",
            textAlign: "right",
            render: (el) => integer(el.sqft),
        });

        columns.push({
            code: "rent_per_sqft",
            name: "Rent/SQFT",
            textAlign: "right",
            render: (el) => dollars(el.rent_per_sqft, true),
        });

        if (isClosed) {
            columns.push({
                code: "close_price_per_sqft",
                name: "Close PSF",
                textAlign: "right",
                render: (el) => pricePerFoot(el.sold_price, el.sqft, true),
            });
        } else if (isNegotiation) {
            columns.push({
                code: "negotiation_price_per_sqft",
                name: "PSF",
                textAlign: "right",
                render: (el) => pricePerFoot(el.negotiation_price, el.sqft, true),
            });
        } else {
            columns.push({
                code: "price_per_sqft",
                name: "PSF",
                textAlign: "right",
                columnStyle: {
                    padding: "0 32px"
                },
                render: (el) => pricePerFoot(el.source === 'HSC' ? el.hsc_price : el.list_price, el.sqft, true),
            });
        }

        if (query.type === "STNL") {
            columns.push({
                code: "lease_expiration_date",
                name: "Remaining Term",
                render: (el) => {
                    if (el.lease_expiration_date) {
                        const ex = new Date(el.lease_expiration_date);
                        let diff;

                        if (el.status && el.status.toLowerCase() === "closed") {
                            const escrowDate = new Date(el.close_of_escrow);
                            diff = ex - escrowDate;
                        } else {
                            const today = new Date();
                            diff = ex - today;
                        }

                        if (diff !== diff) {
                            // NaN
                            return "";
                        }

                        if (diff <= 0) {
                            return "Expired";
                        }

                        return (
                            Math.round((diff / (1000 * 60 * 60 * 24 * 365)) * 10) / 10 +
                            " years"
                        );
                    }

                    return "";
                },
            });

            columns.push({
                code: "lease_type",
                name: "Lease",
                render: (el) => el.lease_type,
            });
        }

        columns.push({
            code: "year_built",
            name: "Year Built",
            textAlign: "center",
            render: (el) => el.year_built,
        });

        if ((query.category === "retail" || query.category === "office") && query.type === "MT") {
            columns.push({
                code: "vacancy",
                name: "Occupancy",
                textAlign: "right",
                render: (el) => (el.vacancy ? el.vacancy + "%" : ""),
            });
        }
    }

    return (
        <div className="ListTable">
            <SortTable
                columns={columns}
                items={props.listings}
                query={query}
                selectedAll={props.selectedAll}
                classNameModifier="properties"
                toggleCheckbox={props.toggleCheckbox}
                toggleAllCheckbox={props.toggleAllCheckbox}
                lastVisited={lastVisited}
            />
        </div>
    );
};

export default ListTable;
